var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTnfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 28,
    viewBox: "0 0 60 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5963 8.68289H19.8207V1.59522H17.2456V0.0715332H24.1685V1.59522H21.5963V8.68289Z",
    fill: "#1A1919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5793 4.82046V8.68289H24.8008V0.0715332H26.5793V3.33615H29.8983V0.0715332H31.6783V8.68289H29.8983V4.82046H26.5793Z",
    fill: "#1A1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5652 1.59522H34.0934V3.40541H38.0346V4.92909H34.0934V7.16212H38.5638V8.68362H32.436V0.0715332H38.5652V1.59522Z",
    fill: "#1A1919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27707 9.56641H6.93877V18.1778H5.15956L1.68621 12.0378H1.66098V18.1778H0V9.56641H1.87293L5.24895 15.562H5.27707V9.56641Z",
    fill: "#1A1919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8368 16.8824C12.7984 16.8824 14.148 16.2824 14.148 13.8722C14.148 11.4628 12.7984 10.8628 11.8368 10.8628C10.8787 10.8628 9.52479 11.4628 9.52479 13.8722C9.52479 16.2824 10.8787 16.8824 11.8368 16.8824ZM11.8368 9.33838C12.965 9.33838 15.9286 9.83121 15.9286 13.8722C15.9286 17.9104 12.965 18.4032 11.8368 18.4032C10.7114 18.4032 7.74414 17.9104 7.74414 13.8722C7.74414 9.83121 10.7114 9.33838 11.8368 9.33838Z",
    fill: "#1A1919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4761 18.1778H26.6991V11.0879H24.1226V9.56641H31.0447V11.0879H28.4761V18.1778Z",
    fill: "#1A1919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4641 14.3168V18.1763H31.687V9.56567H33.4641V12.8266H36.7824V9.56567H38.5638V18.1763H36.7824V14.3168H33.4641Z",
    fill: "#1A1919"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5003 13.3581C21.426 13.3581 21.8766 13.033 21.8766 12.1815C21.8766 11.7273 21.6718 11.0558 20.6315 11.0558H18.4126V13.3581H20.5003ZM16.668 9.56641H20.9754C23.2391 9.56641 23.6536 11.2578 23.6536 12.0036C23.6536 12.9506 23.1756 13.7664 22.3351 14.0551C23.0365 14.3649 23.415 14.6281 23.415 16.2356C23.415 17.4939 23.415 17.8074 23.7942 17.951V18.1778H21.8239C21.7071 17.7731 21.6372 17.3263 21.6372 16.4405C21.6372 15.2645 21.568 14.8104 20.2473 14.8104H18.4126V18.1778H16.668V9.56641Z",
    fill: "#1A1919"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1889 27.6707H11.4126V19.0608H17.469V20.5845H13.1889V22.5266H16.9341V24.0532H13.1889V27.6707Z",
    fill: "#1A1919"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3378 24.4104H21.5063L20.4501 21.0059H20.4307L19.3378 24.4104ZM18.2694 27.6707H16.395L19.4308 19.0608H21.4825L24.4815 27.6707H22.548L22.003 25.8955H18.862L18.2694 27.6707Z",
    fill: "#1A1919"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9429 21.9082C29.8038 21.3942 29.5276 20.4232 28.0606 20.4232C27.2056 20.4232 25.9454 20.9984 25.9454 23.4319C25.9454 24.9782 26.5524 26.3721 28.0606 26.3721C29.0432 26.3721 29.7331 25.8071 29.9429 24.7522H31.7207C31.366 26.6229 30.1599 27.9286 28.0238 27.9286C25.758 27.9286 24.1338 26.3867 24.1338 23.4093C24.1338 20.4006 25.851 18.8638 28.0505 18.8638C30.596 18.8638 31.6248 20.6412 31.7207 21.9082H29.9429Z",
    fill: "#1A1919"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5652 20.5845H34.0934V22.3939H38.0346V23.9176H34.0934V26.1507H38.5638V27.6707H32.436V19.0608H38.5652V20.5845Z",
    fill: "#1A1919"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 20.0274C60 8.99783 51.1738 0.0715332 40.2657 0.0715332H39.875V8.68289H40.2657C46.6119 8.68362 51.7556 13.8372 51.8306 20.2352H51.8313V27.6706H60V20.0274Z",
    fill: "#1A1919"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.266 19.0608H39.876V27.6707H43.9599V22.7956C43.9599 20.731 42.3076 19.0608 40.266 19.0608Z",
    fill: "#1A1919"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.959 20.3364C50.9345 14.3846 46.1657 9.57515 40.2758 9.56641H39.875V18.1778H40.2657C42.7889 18.1778 44.832 20.2424 44.832 22.7955V27.6705H50.959V20.3364Z",
    fill: "#1A1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnfLogo);
export default __webpack_public_path__ + "static/media/tnf-logo.67f2848c1121129e97519a0be34bcecd.svg";
export { ForwardRef as ReactComponent };